<template>
  <sign @done="handleSign"></sign>
</template>
<script>
import Sign from "@components/Sign";
import { Toast } from "vant";
import { signOrder } from "@api/order";
import { mapGetters } from "vuex";
import dayjs from "dayjs";
import { isType } from "@utils";

export default {
  components: {
    Sign,
    Toast,
  },
  props: {},
  data: function () {
    return {
      offlinePayStatus: 2,
      orderTypeName: "普通订单",
      orderTypeNameStatus: true,
      offlineStatus: true,
      id: this.$route.params.id,
      orderInfo: {
        _status: {},
      },
      status: {},
      pay: false,
    };
  },
  computed: {
    ...mapGetters(["userInfo"]),
  },
  watch: {
    $route(n) {
      if (this.id !== n.params.id) {
        this.id = n.params.id;
        this.getDetail();
      }
    },
  },
  inject: ["app"],
  mounted: function () {
    this.getDetail();
  },
  methods: {
    formatDate(time) {
      return dayjs(time).format("YYYY-MM-DD HH:mm:ss");
    },
    goBack() {
      const history = this.app.history;
      const last = history[history.length - 1] || {};
      if (last.name === "MyOrder") {
        return this.$router.go(-1);
      } else {
        return this.$router.replace({ path: "/order/list/1" });
      }
    },
    getDetail: function () {},
    handleSign: function (flag = false) {
      if (isType(flag, "String")) {
        signOrder(this.id, flag).then((res) => {
          Toast(res.message);
          this.$router.replace({ path: "/order/list/2" });
        });
      } else {
        this.$router.replace({ path: "/order/list/1" });
      }
    },
  },
};
</script>
